import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: { marginBottom: theme.spacing(1) },
  label: {
    //width: "10em",
    display: "block",
    fontWeight: "bold",
    fontSize: 14,
  },
  value: {
    display: "block",
    fontSize: 14,
  },
}));

interface IValueWithLabelProps {
  label: string;
  value: any;
  children?: any;
}
const ValueWithLabel = (props: IValueWithLabelProps) => {
  const classes = useStyles();
  const { label, value } = props;

  if (!value) return null;

  return (
    <div className={classes.wrapper}>
      <span className={classes.label}>{label}</span>
      <span className={classes.value}>{props.children || value}</span>
    </div>
  );
};
export default ValueWithLabel;
